export function capitalizeFirstLetter(value: string) {
    return value?.charAt(0)?.toUpperCase() + value?.slice(1);
}

export const camelCaseToText = (value: string) => {
  return capitalizeFirstLetter(value?.replace(/[A-Z]/g, letter => ` ${letter}`))
}

export function getFirstLetters(str: string) {
  const firstLetters = str
    ?.split(' ')
    ?.map(word => word[0])
    ?.join('');

  return firstLetters;
}

export function stringReduceAddDots(value: string, limit: number) {
  if ( String(value).length <= limit) {
      return value;
  } else {
      return `${String(value).slice(0,limit)}...`
  }
}

export const getBaraStatusColor = (status: string) => {
  switch (status) {
    case "EN_ATTENTE":
      return "#0F58AE";
    case "EN_COURS":
      return "#FF7900";
    case "REFUSER":
      return "#FF8888";
    case "TERMINER":
      return "#00833D";
    default:
      return "#c2c2c2";
  }
};